var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"launcher-button",style:(_vm.inlineStyles),attrs:{"href":"#","title":"Order Now!"},on:{"click":function($event){$event.preventDefault();return _vm.showOrderSystem.apply(null, arguments)}}},[_c('span',{staticClass:"badge"},[_vm._v("1")]),(!_vm.launcherIcon)?_c('FoodTraySvg',{staticClass:"food-tray"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }